<template>
  <div
    class="core-dropdown-v2"
    :class="[
      `core-dropdown-v2__mode-${mode}`,
      subClass,
      {
        'disable': disable,
        'core-dropdown-v2--smartphone': $isSmartphone,
        'core-dropdown-v2--has-icon': icon,
      }
    ]"
  >
    <div
      v-if="showContent"
      class="core-dropdown-v2-black-matter"
      @click="clickOutSide"
    />
    <div
      v-if="showBtn"
      :class="[
        buttonClass,
        {
          'active': showContent,
        }
      ]"
      @click="clickButton"
    >
      <div
        v-if="isLoading"
        class="core-dropdown-v2__is-loading"
      >
        <loader />
      </div>
      <div
        v-if="icon"
        class="core-dropdown-v2__button-left-icon"
      >
        <sprite
          :src="icon"
        />
      </div>
      <div
        :class="[
          buttonSlotClass,
          {
            'core-dropdown-v2__content-slot--with-icon': icon
          }
        ]"
      >
        <slot />
      </div>
      <div
        v-if="showRightIcon"
        class="core-dropdown-v2__button-right-icon"
      >
        <sprite
          src="sprites_chevron_down_fixed"
        />
      </div>
    </div>
    <div
      v-if="mode === 'select' || mode === 'modal'"
      class="core-dropdown-v2__content-pos"
    >
      <div
        v-show="showContentLeave"
        class="core-dropdown-v2__content-container"
        :class="[
          wrapperClass,
          {
            'core-dropdown-v2__content-container--modal-mode': mode === 'modal'
          }
        ]"
        @click.self="clickOutSide"
      >
        <transition
          name="slide-top"
          @before-enter="onBeforeEnter"
          @after-leave="onAfterLeave"
        >
          <div
            v-if="showContent"
            ref="content"
            class="core-dropdown-v2__content"
            :class="contentClass"
          >
            <slot name="content" />
          </div>
        </transition>
      </div>
    </div>
    <template
      v-else-if="mode === 'bottom'"
    >
      <transition name="slide-bottom">
        <div
          v-if="showContent"
          :style="swipeStyles"
          class="core-dropdown-v2__bottom-mode-content-container"
          :class="wrapperClass"
        >
          <div class="core-dropdown-v2__drag-plate" />
          <div
            v-if="bottomTitle || bottomSubTitle"
            ref="swipeHandle"
            v-touch:press="touchStart"
            v-touch:drag="movingHandler"
            v-touch:release="endHandler"

            class="core-dropdown-v2__bottom-mode-content-header"
          >
            <div
              v-if="icon"
              class="core-dropdown-v2__bottom-mode-left-icon-wrapper"
              @click="$emit('close')"
            >
              <sprite
                :src="icon"
                class-name="core-dropdown-v2__bottom-mode-left-icon"
              />
            </div>
            <div class="core-dropdown-v2__header-texts">
              <div class="core-dropdown-v2__bottom-mode-content-title">
                {{ bottomTitle }}
              </div>
              <div
                v-if="bottomSubTitle"
                class="core-dropdown-v2__bottom-mode-content-sub-title"
              >
                {{ bottomSubTitle }}
              </div>
            </div>
          </div>
          <div
            class="core-dropdown-v2__bottom-mode-content"
          >
            <slot name="content" />
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import Loader from '@/components/core/ui/Loader'
import swipeDownModal from './mixin/swipeDownModal'
import Velocity from 'velocity-animate'

export default {
  name: 'CoreDropdown',

  components: {
    Loader,
  },

  mixins: [
    swipeDownModal,
  ],

  props: {
    // скрывает кнопку если нужна только модалка
    showBtn: {
      type: Boolean,
      default: true,
    },
    // Включает padding у контента по умолчанию
    paddedContent: {
      type: Boolean,
      default: false,
    },
    transparentContent: {
      type: Boolean,
      default: false,
    },

    // Доп класс для обёртки
    subClass: {
      type: String,
      default: '',
    },

    buttonClass: {
      type: String,
      default: 'core-dropdown-v2__button',
    },

    buttonSlotClass: {
      type: String,
      default: 'core-dropdown-v2__content-slot',
    },

    // Показывать контент
    showContent: {
      type: Boolean,
      default: false,
    },

    // Иконка в левой части, по большей части не нужный параметр
    icon: {
      type: String,
      default: '',
    },
    // Показывать ли икнку справа от кнопки
    showRightIcon: {
      type: Boolean,
      default: true,
    },

    // Разделение клика по кнопке и по лейауту (будет эмитить отдельные данные при клике по темной зоне)
    separateClickOutSideAction: {
      type: Boolean,
      default: false,
    },

    // Отключение кнопки
    disable: {
      type: Boolean,
      default: false,
    },

    // Тип вызываемого окна, может быть:
    // select (селект под кнопкой)
    // bottom (ака ios)
    // modal (всплывашка по центру экрана)
    mode: {
      type: String,
      default: 'select', // bottom,  modal
    },

    // Заголовок для header'а варианта отображения bottom
    bottomTitle: {
      type: String,
      default: '',
    },

    // Подзаголовок для header'а варианта отображения bottom
    bottomSubTitle: {
      type: String,
      default: '',
    },
    // Дисейблим кнопку и показываем лоадер
    isLoading: {
      type: Boolean,
      default: false,
    },

    // Селектор контейнера для прокрутки на декстопе при открытии дропдауна
    container: {
      type: String,
      default: '',
    },

    // для изменения шрины окна и прочее
    wrapperClass: {
      type: String,
      default: '',
    },
  },

  emits: [
    'clickButton',
    'clickOutSide',
    'close',
  ],
  data () {
    return {
      showContentLeave: this.showContent,
    }
  },
  computed: {
    contentClass () {
      return {
        'core-dropdown-v2__padded-content': this.paddedContent,
        'core-dropdown-v2__transparent': this.transparentContent,
      }
    },
  },

  watch: {
    showContent: function (val) {
      if (val) {
        setTimeout(() => {
          const { clientHeight } = document.documentElement
          const { bottom } = this.$refs.content?.getBoundingClientRect() || { bottom: clientHeight }
          if (bottom > clientHeight) {
            const container = this.container !== '' ? document.querySelector(this.container) : undefined
            Velocity(this.$refs.content, 'scroll', {
              duration: 200,
              offset: bottom - clientHeight,
              container,
            })
          }
        }, 400)
      }
    },
  },

  methods: {
    clickButton () {
      if (!this.disable) {
        this.$emit('clickButton', true)
      }
    },

    clickOutSide () {
      if (this.separateClickOutSideAction) {
        this.$emit('clickOutSide', true)
      } else {
        this.$emit('clickButton', true)
      }
    },
    onBeforeEnter () {
      console.log('onBeforeEnter')
      this.showContentLeave = true
    },
    onAfterLeave () {
      console.log('onAfterLeave')
      this.showContentLeave = false
    },
  },
}
</script>

<style lang="scss">
$prefix: 'core-dropdown-v2';

.#{$prefix} {
  position: relative;

  @include typography('b1', 'medium');

  &--has-icon & {
    &__header-texts {
      width: 63%;
    }
  }
}

.#{$prefix}-black-matter {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 120;

  width: 100%;
  height: 100%;
  background: rgba(map-get($colors, 'black_0'), 0.7);
}

.#{$prefix}-active {
  z-index: 130;
}

.#{$prefix}__button {
  display: flex;
  flex-flow: row wrap;
  white-space: nowrap;

  position: relative;
  z-index: 5;

  width: 100%;

  padding: 0.16rem;

  align-items: center;

  border-radius: 0.16rem;

  cursor: pointer;

  background: map-get($colors, 'grey_4');

  .disable & {
    cursor: not-allowed;
  }
}

.#{$prefix}__content-slot {
  @include typography('b1', 'bold');

  width: calc(100% - 0.24rem);

  &.#{$prefix}__content-slot--with-icon {
    width: calc(100% - 0.24rem - 0.2rem);
  }
}

.#{$prefix}__is-loading {
  position: absolute;
  left: 0;
  top: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;

  border-radius: 0.16rem;

  background: rgba(map-get($colors, 'white'), 0.8);
  color: map-get($colors, 'default');
}

.#{$prefix}__content-pos {
  position: relative;
}
.#{$prefix}__content-container {
  position: absolute;

  top: 0.1rem;
  left: -0.08rem;
  z-index: 130;

  width: calc(100% + 0.16rem);
  &--modal-mode {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 7.72rem;
    overflow: auto;
    /* Скрываем scrollbar для Chrome, Safari и Opera */
    &:-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;  /* IE и Edge */
    scrollbar-width: none;  /* Firefox */
    max-height: 100vh;
    border-radius: 0;
    padding: 0.32rem 8px;
    width: 100%;
  }
}

.#{$prefix}__padded-content {
  padding: 0.16rem;
}

.#{$prefix}__content {
  background: map-get($colors, 'white');

  border-radius: 0.08rem;
  box-shadow: 0 4px 16px rgba(map-get($colors, 'black_0'), 0.1);
  overflow: hidden;
  &.#{$prefix}__transparent {
    background: transparent;
    box-shadow: unset;
  }
  .core-dropdown-v2--smartphone & {
    border-radius: 16px;
  }
  .#{$prefix}__modal-mode &{
    .core-dropdown-v2--smartphone & {
      border-radius: 0.32rem;
    }
  }
}

.#{$prefix}__button-left-icon,
.#{$prefix}__button-right-icon
{
  display: flex;
  align-items: center;
}

.#{$prefix}__button-left-icon {
  width: 0.2rem;
  text-align: left;
  color: map-get($colors, 'default');

  .c-icon {
    max-width: 0.2rem;
    max-height: 0.2rem;
  }
}

.#{$prefix}__button-right-icon {
  display: flex;
  justify-content: flex-end;

  width: 0.24rem;
  margin-left: auto;

  text-align: right;
  color: map-get($colors, 'grey_20');

  .c-icon {
    width: 0.12rem;
    height: 0.12rem;

    transition: all .3s ease;

    .#{$prefix}__button.active & {
      transform: rotate(180deg);
    }
  }
}

.#{$prefix}__bottom-mode-content-container {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 130;

  width: 100%;
  max-width: 3.6rem;

  height: auto;
  max-height: 100%;

  overflow-y: auto;
  overflow-x: hidden;

  html.smartphone & {
    max-width: 100%;
  }

  background: map-get($colors, 'white');

  border-radius: 0.32rem 0.32rem 0 0;
}

.#{$prefix}__bottom-mode-content-header {
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 0.16rem 0;

  &:after {
    content: '';

    position: absolute;
    bottom: 0;
    left: 0;

    display: block;

    height: 0.01rem;
    width: 100%;

    background: map-get($colors, 'grey_8');
  }
}

.#{$prefix}__bottom-mode-left-icon-wrapper {
  position: absolute;
  left: 16px;
}

.#{$prefix}__bottom-mode-left-icon {
  color: map-get($colors, 'black');
  width: 18px;
  height: 14px;
}

.#{$prefix}__bottom-mode-content {
  overflow-y: auto;
  overflow-x: hidden;
}

.#{$prefix}__drag-plate {
  position: absolute;
  top: 0.05rem;

  width: 0.24rem;
  height: 0.03rem;
  left: calc(50% - 0.24rem / 2);

  background: map-get($colors, 'grey_8');
  border-radius: 0.02rem;
}

.#{$prefix}__bottom-mode-content-title {
  text-align: center;
  font-size: 0.16rem;
  line-height: 0.24rem;
  font-weight: 700;
  letter-spacing: 0.2px;
}

.#{$prefix}__bottom-mode-content-sub-title {
  text-align: center;
  font-size: 0.12rem;
  line-height: 0.16rem;
  font-weight: 400;
  letter-spacing: 0.2px;
  color: map-get($colors, 'grey_60');
}

.slide-top-leave-active,
.slide-top-enter-active {
  transition: all .3s ease;
}

.slide-top-enter-from,
.slide-top-leave-to {
  opacity: 0;
  top: 0;
}
.slide-top-enter-to,
.slide-top-leave-from {
  opacity: 1;
  top: 0.1rem;
}

.slide-bottom-leave-active,
.slide-bottom-enter-active {
  transition: all 0.4s ease;
}

.slide-bottom-enter-from,
.slide-bottom-leave-to {
  // transform: translate(0, 100%); - пересекаются стили с swipeDownModal и анимация ломается, по этому через bottom
  bottom: -100%;
}

.slide-bottom-enter-to,
.slide-bottom-leave-from {
  // transform: translate(0, 0);
  bottom: 0;
}
</style>
